import React, { useRef, useEffect } from 'react';
import { Dropdown, List, ListItem } from '@doxyme/ui';
import './doctors-dropdown.scss';
export const DoctorsDropdown = ({ isOpen, doctors, onDoctorClick, onClose, }) => {
    const wrapperRef = useRef();
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!wrapperRef.current.contains(event.target)) {
                onClose();
            }
        };
        if (isOpen) {
            document.addEventListener('click', handleClickOutside);
        }
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [onClose, isOpen]);
    return (<div ref={wrapperRef}>
      <Dropdown isOpen={isOpen} className="doctors-dropdown">
        <List aria-label="list of doctors">
          {doctors.map((doctor) => (<ListItem key={doctor.uuid}>
              <button onClick={() => onDoctorClick(doctor.uuid)}>
                <img className="doctor-list-photo" src={doctor.userPicture ?? '/assets/icons/legacy/avatar.svg'} alt="Provider avatar" width="30" height="30"/>
                {doctor.state.username}
              </button>
            </ListItem>))}
        </List>
      </Dropdown>
    </div>);
};
